import { useEffect, useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { BasicTextEditorHandle } from '@factorialco/factorial-one-react/dist/experimental'

import { MeetingSkeleton } from 'modules/meetings/components/Skeletons/MeetingSkeleton'
import { useMeetingDetails } from 'modules/meetings/lib/hooks/useMeetingDetails'
import { useMeetingTranscript } from 'modules/meetings/lib/hooks/useMeetingTranscript'

import { MeetingNotes } from './components/MeetingNotes'
import { PostMeetingSideBar } from './components/PostMeetingSideBar'

const MeetingMeetPage = () => {
  const textEditorRef = useRef<BasicTextEditorHandle>(null)
  const [meetingState, setMeetingState] = useState<'pre' | 'post' | null>(null)
  const { loading: pageDetailsLoading } = useMeetingDetails()

  const { transcript, loadingTranscript } = useMeetingTranscript()

  const haveTranscript = transcript && transcript.length > 0

  useEffect(() => {
    if (loadingTranscript || !transcript) return

    if (haveTranscript) {
      setMeetingState('post')
    } else {
      setMeetingState('pre')
    }
  }, [loadingTranscript, transcript, haveTranscript])

  if (pageDetailsLoading) {
    return <MeetingSkeleton />
  }

  return (
    <Box
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
      }}
      height="full"
    >
      <Box style={{ width: '100%' }} height="full" flexDirection="row" justifyContent="center">
        <Box
          style={{
            maxWidth: meetingState === 'post' ? '100%' : '1024px',
            width: '100%',
          }}
          flexGrow
          position="relative"
          flexDirection="column"
          gap="s16"
        >
          <MeetingNotes textEditorRef={textEditorRef} meetingState={meetingState} />
        </Box>
        {meetingState === 'post' && <PostMeetingSideBar textEditorRef={textEditorRef} />}
      </Box>
    </Box>
  )
}

export default MeetingMeetPage
